import type { DocNode } from '@atlaskit/adf-schema/doc';

/**
 * Page ADF resolution shared by the two Object Sidebar Remix entry points: the button's own
 * popup and the Rovo-sidebar submit coordinator hosted by the lifecycle session. Both start
 * from the same page, so they must not drift on how that page is read.
 */
export type ObjectSidebarRemixAdfSource = {
	contentBodyValue?: string | null;
	getAdfDocument?: () => Promise<DocNode | null>;
};

/** Parses a stored content body into ADF. Returns null when it is absent or not a document. */
export const parseObjectSidebarRemixAdf = (value: string): DocNode | null => {
	try {
		const parsed = JSON.parse(value);
		if (!parsed || parsed.type !== 'doc') {
			return null;
		}
		return parsed as DocNode;
	} catch {
		return null;
	}
};

/** Resolves live editor ADF when available, otherwise the saved renderer content body. */
export const loadObjectSidebarRemixAdf = async ({
	contentBodyValue,
	getAdfDocument,
}: ObjectSidebarRemixAdfSource): Promise<DocNode | null> => {
	if (getAdfDocument) {
		return getAdfDocument();
	}
	if (!contentBodyValue) {
		return null;
	}
	return parseObjectSidebarRemixAdf(contentBodyValue);
};
